import React from 'react'
import ffffff from '../image/ffffff.avif'
import { styled } from '@mui/system'
import Accordion from '@mui/material/Accordion'
import AccordionSummary from '@mui/material/AccordionSummary'
import AccordionDetails from '@mui/material/AccordionDetails'
import Typography from '@mui/material/Typography'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
const useStyles = styled((theme) => ({
  root: {
    width: '100%',
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    flexBasis: '33.33%',
    flexShrink: 0,
  },
  secondaryHeading: {
    fontSize: theme.typography.pxToRem(15),
    color: theme.palette.text.secondary,
  },
}))

function FSW_FAQ_page() {
  return (
    <div>
      <div className="mt-5 ">
        <div className="container pt-3">
          <div className="text-center Curriculum_Main_text">
            <div className="">
              <h2 className="display-6">Frequently Asked Questions</h2>
              <p className="pt-2">
                Our Responses to Your Inquiries: Unblocking the Way to Clarity
              </p>
            </div>
          </div>
          <div className="row">
            <div className="col-md-5">
              <div className="FAQ_img">
                <img
                  src={ffffff}
                  onContextMenu={(e) => e.preventDefault()}
                ></img>
              </div>
            </div>
            <div className="col-md-7 pt-5 d-none d-md-block">
              <div className="pt-5">
                <div className="pt-5">
                  <div className="pt-5">
                    <FSW_FAQ />
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-12 d-sm-block d-md-none mb-5">
              <FSW_FAQ />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

function FSW_FAQ() {
  const classes = useStyles()
  const [expanded, setExpanded] = React.useState(false)

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false)
  }

  return (
    <div className={classes.root}>
      <Accordion
        className="py-2"
        expanded={expanded === 'panel1'}
        onChange={handleChange('panel1')}
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1bh-content"
          id="panel1bh-header"
          className="FAQ_background_color"
        >
          <Typography style={{ fontSize: '1.2rem' }}>
            What do Full Stack Web Developers do?
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
            A full Stack net Developer is someone who is acquainted with
            developing each consumer and server software. Further to learning
            CSS and HTML, they’re additionally know how to program browsers,
            databases, and servers.
            <br></br>To fully comprehend the function of complete Stack
            developer, you need to recognize the net development additives –
            front quit and back quit
            <br></br>ont end accommodates a visible a part of the software in
            which the user interacts, even as the returned stop includes
            enterprise logic.
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion
        className="py-2"
        expanded={expanded === 'panel2'}
        onChange={handleChange('panel2')}
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel2bh-content"
          id="panel2bh-header"
          className="FAQ_background_color"
        >
          <Typography style={{ fontSize: '1.2rem' }}>
            What skills do you need to be a full-stack developer?
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
            A full Stack developer must be acquainted with:
            <br></br>
            <ul>
              <li>
                Simple languages – have to be talented in fundamental languages
                like HTML, CSS, and sq..
              </li>
              <li>
                Front-cease frameworks – BootStrap, AngularJS, VueJS, ReactJS,
                JavaScript, TypeScript, Python, Ruby, Hypertext Preprocessor
              </li>
              <li>
                Back-give up frameworks – express, Django, NodeJS, Ruby on Rails
              </li>
              <li>
                Databases – MySQL, SQLite, Postgres, MongoDB, Cassandra, Apache
                storm, Sphinx
              </li>
              <li>
                Additional talents advocated – Git, gadget studying, SSH, Linux
                Command, statistics systems, person encoding.
              </li>
            </ul>
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion
        className="py-2"
        expanded={expanded === 'panel3'}
        onChange={handleChange('panel3')}
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel3bh-content"
          id="panel3bh-header"
          className="FAQ_background_color"
        >
          <Typography style={{ fontSize: '1.2rem' }}>
            Explain Pair Programming?
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
            As the name suggests, Pair Programming is where two programmers
            share a single workstation. Formally, one programmer at the keyboard
            called the “driver” writes the code. The other programmer is the
            “navigator” views each line of the code written, spell check, and
            proofread it. Also, programmers will swap their roles every few
            minutes and vice-versa.
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion
        className="py-2"
        expanded={expanded === 'panel4'}
        onChange={handleChange('panel4')}
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel4bh-content"
          id="panel4bh-header"
          className="FAQ_background_color"
        >
          <Typography style={{ fontSize: '1.2rem' }}>
            Explain Pair Programming?
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
            As the name suggests, Pair Programming is where two programmers
            share a single workstation. Formally, one programmer at the keyboard
            called the “driver” writes the code. The other programmer is the
            “navigator” views each line of the code written, spell check, and
            proofread it. Also, programmers will swap their roles every few
            minutes and vice-versa.
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion
        className="py-2"
        expanded={expanded === 'panel5'}
        onChange={handleChange('panel5')}
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel5bh-content"
          id="panel5bh-header"
          className="FAQ_background_color"
        >
          <Typography style={{ fontSize: '1.2rem' }}>
            Explain Pair Programming?
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
            As the name suggests, Pair Programming is where two programmers
            share a single workstation. Formally, one programmer at the keyboard
            called the “driver” writes the code. The other programmer is the
            “navigator” views each line of the code written, spell check, and
            proofread it. Also, programmers will swap their roles every few
            minutes and vice-versa.
          </Typography>
        </AccordionDetails>
      </Accordion>
    </div>
  )
}
export default FSW_FAQ_page
